import { FileNameData } from "../FileNameData";

export class OvertimeRequest {
    constructor(
        public id: number,
        public employeeId: number,
        public overtimeDate: string,
        public overtimeTypeId: number,
        public description: string,
        public filePath: string,
        public readAndAprroved: number,
        public fileList: FileNameData[],
        public branchCode: string = null,
        public startTime: string = null,
        public endTime: string = null,
        public isRestDay: number = 0,
        public projectCode: string = null,
        public tenantCode: string = null
    ) {}
}